import React from 'react'
import * as UI from 'ui'
import * as Columns from 'support/columns'
import TranslatedTitle from 'widgets/TranslatedTitle'
import { Translation, Translator } from '@morningtrain/react-translations'
import {
  Collection,
  ExecuteOperationForModelOnPipe,
  ExecuteOperationOnPipe, useValue,
  WhenCollectionIsNotEmpty
} from '@morningtrain/react-resources'
import { Table } from 'widgets/crud'
import { Pipeline, TriggerPipelineOnClick } from '@morningtrain/react-helpers'
import { MountSmartviewOnPipe, MountSmartviewOnSelection } from '@morningtrain/react-smartviews'
import EditTabletSmartview from 'widgets/smartviews/tablets/EditTabletSmartview'
import { PaginationFilter, SelectedDepartmentFilter } from 'support/filters'

import * as Icons from 'ui/icons'
import { CanUseModel } from '@morningtrain/react-auth'
import { StaticFilter } from '@morningtrain/react-filters'

export default function Tablets (props) {
  const departmentId = useValue('id')

  return (
    <Translator namespace='settings.tablets'>
      <UI.PageHeader title={<Translation name='title' />}>
        <Pipeline>
          <TriggerPipelineOnClick>
            <UI.Button>
              <Translation name='actions.create' />
            </UI.Button>
          </TriggerPipelineOnClick>
          <MountSmartviewOnPipe smartview={<EditTabletSmartview department={departmentId} create />} replace={false} />
        </Pipeline>
      </UI.PageHeader>
      <Collection resourceName='tablets'>
        <StaticFilter name='department' value={departmentId} />

        <MountSmartviewOnSelection smartview={<EditTabletSmartview department={departmentId} />} replace={false} />

        <UI.Card>
          <WhenCollectionIsNotEmpty>
            <Table>
              <Columns.Text name='name' label={<Translation name='columns.name' />} />
              <Columns.Text name='authorization_code' label={<Translation name='columns.code' />} />
              <Columns.DateTime name='last_activity_at' label={<Translation name='columns.last_activity_at' />} />
              <Columns.Column alignment='right'>
                <UI.ButtonWrap wrap={false} className=''>
                  <CanUseModel permission='api.tablets.reset'>
                    <Pipeline>
                      <TriggerPipelineOnClick>
                        <UI.SquareButton color='btn-lightgray' className='p-2'>
                          <Icons.Refresh />
                        </UI.SquareButton>
                      </TriggerPipelineOnClick>
                      <ExecuteOperationForModelOnPipe resourceName='tablets' operationName='reset' />
                      <ExecuteOperationOnPipe resourceName='tablets' operationName='index' />
                    </Pipeline>
                  </CanUseModel>
                  <UI.DefaultEditButton />
                </UI.ButtonWrap>
              </Columns.Column>
            </Table>
          </WhenCollectionIsNotEmpty>
          <PaginationFilter />
        </UI.Card>
      </Collection>
    </Translator>
  )
}
